export default __webpack_public_path__ + "static/media/signin.f5bdabc1.png";